<template>

  <div class="row">
    <!--  员工列表  -->
    <div class="flex xs12">
      <va-card title="用户">
        <div class="row align--center mb-1">
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="nickname"
              placeholder="search by nickname"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-button flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="employees"
          :loading="loading"
          api-mode
        >
          <template slot="nickname" slot-scope="props" >
            <div>{{props.rowData.nickname}}</div>
            <va-badge color='warning' v-show="props.rowData.id == loginId">本人</va-badge>
          </template>
          <template slot="role" slot-scope="props" >
            <va-badge color='info' v-for="role in employeeRoleMap[props.rowData.id]" :key="role">{{role}}</va-badge>
          </template>
          <template slot="assignRoles" slot-scope="props">
            <va-popover message="分配角色" placement="top">
              <va-button flat color="gray" icon="fa fa-plus-square"
                @click="listRole();selectedEmployeeId = props.rowData.id; roles=employeeRoleMap[props.rowData.id];assignRoleModal=true"/>
            </va-popover>
          </template>
          <template slot="libaUid" slot-scope="props" >
            <div>{{flipUser[props.rowData.libaUid] }}</div>
          </template>
          <template slot="assignUid" slot-scope="props">
            <va-popover message="分配uid" placement="top">
              <va-button flat color="gray" icon="fa fa-plus-square"
                @click="
                  selectedUid=computedSelectedUid(props.rowData.libaUid);
                  selectedEmployeeId = props.rowData.id;
                  assignUidModal=true"
              />
            </va-popover>
            <va-popover message="解除绑定" placement="top">
              <va-button flat small color="gray" icon="fa fa-user-times"
                @click="removeLibaUidModal = true;selectedEmployeeId = props.rowData.id;"  />
            </va-popover>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="删除" placement="top" v-show="props.rowData.id != loginId">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"  />
            </va-popover>
            <va-popover message="编辑个人资料" placement="top" v-show="props.rowData.id == loginId">
              <va-button flat small color="gray" icon="fa fa-address-card-o"  :to='{path:`updateEmployee/${props.rowData.id}`}'/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除员工"
          okText="提交"
          position="center"
          message="请再次确认是否要删除用户？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="removeLibaUidModal"
          title="解除uid绑定"
          okText="提交"
          position="center"
          message="请再次确认是否要解除绑定？"
          @ok="confirmRemoveLibaUid"
        />
        <va-modal v-model="assignRoleModal" title="分配角色"
          okText="提交" position="center" message="请再次确认是否分配该角色？"
          @ok="confirmAssignRoles">
          <va-select
            multiple
            v-model="roles"
            label="请选择角色"
            :options="roleOptions"
            searchable
            width="350px"
          />
        </va-modal>
        <va-modal v-model="assignUidModal" title="绑定uid"
          okText="提交" position="center" message="请再次确认是否分配该uid？"
          @ok="confirmAssignUid">
          <va-select
            v-model="selectedUid"
            label="请选择uid"
            :options="userUidOptions"
            searchable
            width="350px"
          />
        </va-modal>

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import employeeApi from '../../api/employee'
import roleApi from '@/api/role'
import userApi from '@/api/user'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      employees: [],
      nickname: null,
      loading: true,
      pageSize: 10,
      users: [],
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      assignRoleModal: false,
      selectedEmployeeId: null,
      assignUidModal: false,
      removeLibaUidModal: false,
      employeeRoleMap: {},
      roles: [],
      roleMap: {},
      roleOptions: [],
      selectedUid: '',
      userMapNicknameToUid: {},
      userMapUidToNickname: {},
      userUidOptions: [],
      loginId: localStorage.getItem('employeeId'),
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:nickname',
          title: '员工姓名',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:role',
          title: '角色',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:assignRoles',
          title: '分配角色',
          width: '5%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:libaUid',
          title: 'uid',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:assignUid',
          title: '绑定uid',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
    flipUser() {
      const flipUser = []
      this.users.forEach(x => {
        flipUser[x.uid] = x.nickname + '(' + x.uid + ')'
      })
      return flipUser
    },
  },
  created () {
    this.listEmployee()
    this.listUser()
    console.log(localStorage.getItem('employeeId'))
  },

  methods: {
    listEmployee () {
      this.loading = true
      const params = {
        nickname: this.nickname,
        roleId: this.$route.query.roleId,
      }
      employeeApi.listEmployee(params).then(response => {
        this.employees = response.employees
        this.employees.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalCount = response.totalCount
        this.loading = false
        this.employees.forEach(employee => {
          this.employeeRoleMap[employee.id] = []
          employee.roles.forEach(role => {
            this.employeeRoleMap[employee.id].push(role.displayName)
          })
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    listRole () {
      this.roleOptions = []
      roleApi.listRoles().then(response => {
        response.roles.map(x => {
          this.roleMap[x.displayName] = x.id
          this.roleOptions.push(x.displayName)
        })
      }).catch(error => alert(error))
    },
    listUser () {
      const params = {
        pageNumber: 1,
        pageSize: 10000,
      }
      userApi.listUser(params).then(response => {
        this.users = response.users
        response.users.map(x => {

          this.userMapNicknameToUid[x.nickname + '(' + x.uid + ')'] = x.uid
          this.userMapUidToNickname[x.uid] = x.nickname
          this.userUidOptions.push(x.nickname + '(' + x.uid + ')')
        })
      })
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') { this.nickname = null }
      this.listEmployee()
    }, 400),
    confirmAssignRoles () {
      const data = {
        employeeId: this.selectedEmployeeId,
        roleIds: [],
      }
      this.roles.forEach(displayName => {
        data.roleIds.push(this.roleMap[displayName])
      })
      employeeApi.assignRoles(data).then(response => {
        if (response.success === true) {
          this.showToast('分配角色成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.selectedEmployeeId = null
          this.listEmployee()
        }
      }).catch(error => {
        this.selectedEmployeeId = null
        this.showToast(error.msg, {
          duration: 5000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmAssignUid () {
      const data = {
        employeeId: this.selectedEmployeeId,
        libaUid: this.userMapNicknameToUid[this.selectedUid],
      }
      employeeApi.assignLibaUid(data).then(response => {
        if (response.success === true) {
          this.showToast('绑定uid成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.selectedEmployeeId = null
          this.listEmployee()
        }
      }).catch(error => {
        this.selectedEmployeeId = null
        this.showToast(error.msg, {
          duration: 5000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      employeeApi.deleteEmployee(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除员工成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listEmployee()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmRemoveLibaUid () {
      if (this.selectedEmployeeId === null) return
      const data = { employeeId: this.selectedEmployeeId }
      employeeApi.removeLibaUid(data).then(response => {
        if (response.success === true) {
          this.showToast('解除绑定成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listEmployee()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computedSelectedUid (libaUid) {
      if (libaUid === '' || this.userMapUidToNickname[libaUid] == null) {
        return ''
      }
      return this.userMapUidToNickname[libaUid] + '(' + libaUid + ')'
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
